export default __webpack_public_path__ + "static/media/vXvs.23ad386b.svg";